import SigninComponent from "../lib/bandung/components/Signin/SigninComponent";
import { Stack, Typography } from "@mui/material";
import VideoChatIcon from "@mui/icons-material/VideoChat";

export default function Signin() {
  return (
    <>
      <div className="login-page-wrapper w-full py-10">
        <div className="container-x mx-auto">
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            margin={"2em 0"}
          >
            <SigninComponent
              header={
                <>
                  <VideoChatIcon fontSize={"large"} />
                  <Typography variant={"h5"}>One2Talk</Typography>
                  <Typography variant={"h6"}>Sign in</Typography>
                </>
              }
              navigateAwayPath={"/dashboard"}
            />
          </Stack>
        </div>
      </div>
    </>
  );
}
